import { createFileRoute, redirect } from "@tanstack/react-router";
import { ReadFeedbackClient } from "@/features/purchaseInvoices/ReadFeedbackClient";
import { firstAllowedRoute, hasModule } from "@/lib/auth";

// Leesmeldingen: what was reported with "Lezen klopt niet" on a purchase invoice (docs/inkoopfacturen.md §5.5).
export const Route = createFileRoute("/_shell/purchase-invoices/read-feedback")(
  {
    beforeLoad: ({ context }) => {
      const { session } = context;
      if (
        !session.roles.includes("admin") &&
        !hasModule(session, "purchase_invoices") &&
        !hasModule(session, "purchase_invoices_write")
      ) {
        throw redirect({ to: firstAllowedRoute(session) });
      }
    },
    component: ReadFeedbackScreen,
  },
);

function ReadFeedbackScreen() {
  const { session } = Route.useRouteContext();
  const canWrite =
    session.roles.includes("admin") ||
    hasModule(session, "purchase_invoices_write");
  return (
    <div className="wl-page" data-screen-label="Back-office Read Feedback">
      <ReadFeedbackClient canWrite={canWrite} />
    </div>
  );
}
